import { gql } from "@apollo/client";

export const CAMBIO_FLUJO_A_RI = gql`
    mutation CambioFlujoARI($input: AddAsistencialNotificationInput!) {
        cambioFlujoIIToRI(input: $input)
    }
`;